import { isNil } from 'lodash-es';

/**
 * Read and write from local storage.
 * used to restore state between sessions.
 */
export class AppStateStorage {
  private stateKey = 'interact_state';

  private makeStateStoreKey(storeName: string) {
    return `${this.stateKey}__${storeName}`;
  }

  read<T>(storeName: string): T {
    const lsKey = this.makeStateStoreKey(storeName);
    const storeJson = localStorage.getItem(lsKey);
    if (storeJson) {
      try {
        return JSON.parse(storeJson) as T;
      } catch (error) {
        console.error(error, storeName);
      }
    }
    return null;
  }

  write<T>(storeName, data: T): void {
    const lsKey = this.makeStateStoreKey(storeName);
    if (isNil(data)) {
      localStorage.removeItem(lsKey);
    } else {
      localStorage.setItem(lsKey, JSON.stringify(data));
    }
  }

  clearStore(storeName) {
    const lsKey = this.makeStateStoreKey(storeName);
    localStorage.removeItem(storeName);
  }

  /**
   * Clears all items from AppState storage
   */
  clearAll() {
    Object.keys(localStorage)
      .filter(key => key.includes(this.stateKey))
      .forEach(key => localStorage.removeItem(key));
  }
}
